import { jsx as e } from "react/jsx-runtime";
import { Loader as i } from "../../loader/index.mjs";
import { twMerge as r } from "tailwind-merge";
function c({ loaderWrapperClassName: t, loaderClassName: o }) {
  return /* @__PURE__ */ e(
    "div",
    {
      className: r(
        "flex h-full items-center justify-center",
        "scale-75",
        t
      ),
      children: /* @__PURE__ */ e(i, { className: r(o) })
    }
  );
}
export {
  c as ListLoader
};
